/** 与后端权限 code 一致（不区分大小写）：可编辑、系统管理可改业务配置 */
export function hasEditableOrSystemAdminPermission(codes: string[] | undefined): boolean {
  return (codes ?? []).some(c => {
    const n = c?.trim().toLowerCase();
    return n === 'editable' || n === 'system_admin';
  });
}

export function hasSystemAdminPermission(codes: string[] | undefined): boolean {
  return (codes ?? []).some(c => c?.trim().toLowerCase() === 'system_admin');
}

/** 可查看及以上（viewable / editable / system_admin） */
export function hasViewableOrHigherPermission(codes: string[] | undefined): boolean {
  return (codes ?? []).some(c => {
    const n = c?.trim().toLowerCase();
    return n === 'viewable' || n === 'editable' || n === 'system_admin';
  });
}
